<div>
    <div class="netzzuordnung-import-toolbar">
        <div class="buttons">
            <button matButton="outlined" class="actionbutton" data-qa="import-id-csv-button"
                    (click)="openNzIdImportWizard()">
                <mat-icon>cloud_download</mat-icon>
                Austausch Netzzuordnung-ID
            </button>
            <button matButton="outlined" class="actionbutton" data-qa="edit-button" (click)="editImportRegel()">
                <mat-icon svgIcon="innogy_picto_pen"></mat-icon>
                Importregel editieren
            </button>
        </div>

        <table mat-table
               class="import-regel-table"
               [dataSource]="importRegelList">

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
            <tr style="cursor: pointer" mat-row *matRowDef="let importRegeln; columns: columnsToDisplay"
                role="link"
                tabindex="0"
                (click)="editImportRegel()"
                (keydown.enter)="editImportRegel()"
            ></tr>

            <ng-container matColumnDef="rulename">
                <th mat-header-cell *matHeaderCellDef>Import-Regel</th>
                <td mat-cell *matCellDef="let importRegel;">{{ importRegel.rulename }}</td>
            </ng-container>

            <ng-container matColumnDef="value">
                <th mat-header-cell *matHeaderCellDef>Grenzwert</th>
                <td mat-cell *matCellDef="let importRegel;">
                    @if (importRegel.key === 'limitAenderungLeistung') {
                        <div>
                            {{ (importRegel.value * 1000.0) | leistungseinheit:Leistungseinheit.MW }}
                        </div>
                    } @else {
                        <div>
                            {{ importRegel.value }}
                        </div>
                    }
                </td>
            </ng-container>

        </table>
    </div>

</div>
